import request from '@/request/request'

// 查询用户列表
export function listUser(query) {
    return request({
        url: '/api/permission/user/list',
        method: 'get',
        params: query
    })
}

// 查询用户列表面验证
export function listUserApp(query) {
    return request({
        url: '/api/permission/user/list',
        method: 'get',
        params: query,
        headers: {
            ignoreValidate: true
        }
    })
}

// 查询用户详细
export function getUserById(id) {
    return request({
        url: '/api/permission/user/' + id,
        method: 'get'
    })
}

// 新增用户
export function addUser(data) {
    return request({
        url: '/api/permission/user',
        method: 'post',
        data: data
    })
}

// 修改用户
export function updateUser(data) {
    return request({
        url: '/api/permission/user/edit',
        method: 'post',
        data: data
    })
}

// 删除用户
export function delUser(userId) {
    return request({
        url: '/api/permission/user/delete/' + userId,
        method: 'post',
    })
}

// 修改用户状态
export function changeUserStatus(data) {
    return request({
        url: '/api/permission/user/changeStatus',
        method: 'post',
        data: data
    })
}
// 修改用户密码
export function resetUserPwd(data) {
    return request({
        url: '/api/permission/user/resetPwd',
        method: 'post',
        data: data
    })
}

// 获取用户角色
export function getUserRole(userId) {
    return request({
        url: '/api/permission/user/authRole/' + userId,
        method: 'get'
    })
}

// 修改用户角色
export function updateUserRole(query) {
    return request({
        url: '/api/permission/user/authRole',
        method: 'post',
        params: query
    })
}